import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
import Timeout from "await-timeout";
import { NavWrapper } from "./styles";
import Interviews from "./interviews";
import CandidateProfile from "./candidateProfile";
import MedicalStudies from "./medicalStudies";
import FormEditCandidato from "./formEditCandidatoNp";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import { removeFile } from "../../../services/fileServices";
import { validateEmail } from "../utils";
import { getUbicacion } from "../../../services/avisosNPServices";

const estudiosOptions = [
  { label: "Primario", value: "Primario" },
  { label: "Secundario", value: "Secundario" },
  { label: "Terciario", value: "Terciario" },
  { label: "Universitario", value: "Universitario" },
];

const nivelDeEstudiosOptions = [
  { label: "Completo", value: "Completo" },
  { label: "Incompleto", value: "Incompleto" },
  { label: "Abandonado", value: "Abandonado" },
];

const EditCandidatoFormModal = ({ toggle, isOpen, info, handleEditCandidatoNp, vacantes, cobertura, derivacionId, notaDePedidoId, canCreateOV }) => {
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const {
    id,
    apellido,
    nombre,
    email,
    cuil,
    telefono,
    portal,
    estado,
    Files,
    fechaDeIngreso,
    ubicacionNPId,
    ubicacion,
    estudiosAcademicos,
    areaDeExperienciaLaboral,
    idiomasCandidatosNP,
    titulo,
  } = info.candidato;
  const { createdAt, motivo, motivoOtro, observaciones } = info;
  const [portalValue, setPortalValue] = useState({ label: portal, value: portal });
  const [categories, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined);
  const portales = categories && categories.portal ? categories.portal.type : [];
  const estadosCandidato = categories && categories.estadoCandidatoNP ? categories.estadoCandidatoNP.type : [];
  const [estadoValue, setEstadoValue] = useState("");
  const fechaActual = moment().format("YYYY-MM-DD");
  const [fechaDeIngresoValue, setFechaDeIngresoValue] = useState(fechaDeIngreso || fechaActual);
  const [showFechaDeIngreso, setShowFechaDeIngreso] = useState(false);
  const [fileId, setFileId] = useState(null);
  const [files, setFiles] = useState(null);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [showMotivoNoAvanzaModal, setShowMotivoNoAvanzaModal] = useState(false);
  const [showActiveNotaModal, setShowActiveNotaModal] = useState(false);
  const [motivoValue, setMotivoValue] = useState(null);
  const [motivoOtroValue, setMotivoOtroValue] = useState(null);
  const motivos = categories && categories.estadoCandidatoNP && categories.estadoCandidatoNP.motivos;
  // setear ciudad y provincia value correspondiente al candidato
  const [provinciaValue, setProvinciaValue] = useState(ubicacion && ubicacion.provincia ? { label: ubicacion.provincia, value: ubicacion.provincia } : null);
  const [ciudades, isLoadingCiudades] = useFetcher(getUbicacion, [{ provincia: provinciaValue && provinciaValue.value }]);
  const [ciudadValue, setCiudadValue] = useState(null);
  const provincias = categories && categories.provinciasNP ? categories.provinciasNP : [];
  const areasDeExperiencia = categories && categories.estadoCandidatoNP ? categories.estadoCandidatoNP : [];
  const [areasDeExperienciaValue, setAreasDeExperienciaValue] = useState(null);
  const [estudiosValue, setEstudiosValue] = useState(null);
  const [nivelDeEstudiosValue, setNivelDeEstudiosValue] = useState(null);

  const areaDeExperienciaOptions =
    areasDeExperiencia && areasDeExperiencia.areaAdministracionLaboral
      ? areasDeExperiencia.areaAdministracionLaboral

          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleMotivoNoAvanza = (values) => {
    setMotivoValue(values.motivo);
    setMotivoOtroValue(values.motivoOtro);
  };

  useEffect(() => {
    if (Files && Files.length > 0) {
      setFileName(Files[0].originalname);
      setFileId(Files[0].id);
    }
  }, [info]);

  useEffect(() => {
    if (estadoValue) {
      if (estadoValue.value === 5) {
        setShowFechaDeIngreso(true);
      } else {
        setShowFechaDeIngreso(false);
      }
      return true;
    }
    return true;
  }, [estadoValue]);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFileName(selectedFiles[0].name);
    setFiles(selectedFiles);
  };

  const handleDeleteCV = async () => {
    try {
      if (fileId) await removeFile({ entity: "candidatosNP", entityId: id, fileId });
      setFileName("Seleccione un archivo");
      setFiles(null);
      toast.success("CV eliminado con éxito");
    } catch (error) {
      handleErrors(toast, error);
    }
  };

  const portalesOptions = portales
    ? portales
        .map((e) => {
          return { label: e.text, value: e.text };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const estadosOptions = estadosCandidato
    ? estadosCandidato.map((e) => {
        return { label: e.text, value: e.id };
      })
    : [];

  const ciudadOptions =
    ciudades && ciudades.ubicacionNP && ciudades.ubicacionNP.length > 0
      ? ciudades.ubicacionNP
          .map((e) => {
            return { label: e.ciudad, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const provinciaOptions = provincias && provincias.type ? provincias.type : [];

  let estadosOptionsFiltered;
  if (derivacionId) {
    // ver opciones al momento de tener vacantes cubiertas
    if (estado === 4 && cobertura !== vacantes) {
      estadosOptionsFiltered = estadosOptions.filter((e) => e.value === 1 || e.value === 2 || e.value === 5 || e.value === 6 || e.value === 7);
    } else if (cobertura === vacantes) {
      // estadosOptionsFiltered = ["Reclutando", "No Ingresa", "Recutando preventiva", "Postulando"];
      estadosOptionsFiltered = estadosOptions.filter((e) => e.value === 1 || e.value === 2 || e.value === 6 || e.value === 7);
    } else {
      // estadosOptionsFiltered = muestra todos excepto "Derivado"
      estadosOptionsFiltered = estadosOptions.filter((e) => e.value !== 3);
    }
  }
  if (!derivacionId) {
    // estadosOptionsFiltered = ["Reclutando", "No Ingresa","Recutando preventiva", "Postulando"];
    estadosOptionsFiltered = estadosOptions.filter((e) => e.value === 1 || e.value === 2 || e.value === 6 || e.value === 7);
  }

  // actualiza el estado del candidato con el que tiene en db
  useEffect(() => {
    if ((notaDePedidoId || derivacionId) && estadosCandidato && estadosCandidato.length > 0) {
      setEstadoValue(estadosOptions.find((e) => e.value === info.estado));
    } else if (estado && estadosCandidato && estadosCandidato.length > 0) {
      setEstadoValue(estadosOptions.find((e) => e.value === estado));
    }
  }, [estado, estadosCandidato]);

  function getFunctionToFilter(filter, selected) {
    if (filter === "portal") {
      setPortalValue(selected);
    }
    if (filter === "estado") {
      setEstadoValue(selected);
      if (selected.value === 6) setShowMotivoNoAvanzaModal(true);
    }
    if (filter === "provincia") {
      setProvinciaValue(selected);
    }
    if (filter === "ciudad") {
      setCiudadValue(selected);
    }
    if (filter === "areaDeExperiencia") {
      setAreasDeExperienciaValue(selected);
    }
    if (filter === "estudios") {
      setEstudiosValue(selected);
    }
    if (filter === "nivelDeEstudios") {
      setNivelDeEstudiosValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaDeIngresoValue(fechaFormateada);
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      nombre: "",
      apellido: "",
      email: "",
      cuil: "",
      telefono: "",
      portal: "",
      estado: "",
      observaciones: "",
      motivo: "",
      motivoOtro: "",
      ubicacionNPId: "",

      areaDeExperienciaLaboral: null,
      titulo: "",
      ingles: "",
      frances: "",
      portugues: "",
      aleman: "",
      chino: "",
      estudiosAcademicos: "",
    },
    onSubmit: async (values) => {
      const dataToEdit = {
        ...values,
        telefono: values.telefono ? JSON.stringify(values.telefono) : "",
        cuil: values.cuil ? JSON.stringify(values.cuil) : "",
        portal: portalValue.value ? portalValue.value : "",
        estado: estadoValue.value ? estadoValue.value : "",
        motivo: motivoValue || motivo,
        motivoOtro: motivoOtroValue || motivoOtro,
        // observaciones: observaciones || null, TODO: revisar este campo
        ubicacionNPId: ciudadValue && ciudadValue.value,
        areaDeExperienciaLaboral: areasDeExperienciaValue && areasDeExperienciaValue.value,
        estudiosAcademicos:
          estudiosValue && estudiosValue.value && nivelDeEstudiosValue && nivelDeEstudiosValue.value ? `${estudiosValue.value} ${nivelDeEstudiosValue.value}` : "",
      };
      if (derivacionId) {
        dataToEdit.derivacionId = derivacionId;
      }
      if (notaDePedidoId) {
        dataToEdit.notaDePedidoId = notaDePedidoId;
      }

      if (showFechaDeIngreso) {
        dataToEdit.fechaDeIngreso = fechaDeIngresoValue;
      }

      try {
        if (estadoValue.value === 6 && !(motivoValue || motivo)) {
          toast.error("Debe seleccionar un motivo para el estado 'No avanza'");
          return;
        }
        if (!areasDeExperienciaValue) {
          toast.error("Debe seleccionar un area de experiencia laboral");
          return;
        }
        // el 3er parametro valida si el candidato tiene archivo para hacer un patch
        handleEditCandidatoNp(dataToEdit, files, fileId);
        await Timeout.set(1000);
        toggle();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required("Este campo es requerido.")
        .test("is-valid-email", "Debe ingresar un correo electrónico válido", (value) => validateEmail(value)),
    }),
  });

  useEffect(() => {
    if (info) {
      if (ciudadOptions && ciudadOptions.length > 0) setCiudadValue(ciudadOptions && ciudadOptions.find((e) => e.value === ubicacionNPId));
    }
  }, [info, isLoadingCiudades]);

  useEffect(() => {
    formik.setValues({
      id: id || "",
      nombre: nombre || "",
      apellido: apellido || "",
      email: email || "",
      titulo: titulo || "",
      ingles: idiomasCandidatosNP && idiomasCandidatosNP.ingles ? idiomasCandidatosNP.ingles : "",
      frances: idiomasCandidatosNP && idiomasCandidatosNP.frances ? idiomasCandidatosNP.frances : "",
      portugues: idiomasCandidatosNP && idiomasCandidatosNP.portugues ? idiomasCandidatosNP.portugues : "",
      aleman: idiomasCandidatosNP && idiomasCandidatosNP.aleman ? idiomasCandidatosNP.aleman : "",
      chino: idiomasCandidatosNP && idiomasCandidatosNP.chino ? idiomasCandidatosNP.chino : "",
      cuil: cuil ? JSON.parse(cuil) : null,
      telefono: telefono ? JSON.parse(telefono) : null,
      observaciones: observaciones || null,
      motivo: motivo || null,
      motivoOtro: motivoOtro || null,
      ubicacionNPId: ubicacionNPId || null,
    });

    if (estudiosAcademicos) {
      const [estudios, nivelDeEstudios] = estudiosAcademicos.split(" ");
      setEstudiosValue(estudios ? estudiosOptions.find((e) => e.value === estudios) || "" : null);
      setNivelDeEstudiosValue(nivelDeEstudios ? nivelDeEstudiosOptions.find((e) => e.value === nivelDeEstudios) || "" : null);
    }
  }, [info]);

  useEffect(() => {
    if (areaDeExperienciaLaboral) {
      setAreasDeExperienciaValue(areaDeExperienciaOptions.find((e) => e.value === areaDeExperienciaLaboral) || "");
    }
  }, [areaDeExperienciaLaboral, isLoadingCategoies]);

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }} size="lg">
          <ModalHeader toggle={toggle} style={{ borderBottom: "none", background: "#f8f8f8" }}>
            {`Candidato/ ${apellido} ${nombre}`}
          </ModalHeader>
          <ModalBody style={{ background: "#f8f8f8", alignItems: "flex-start" }}>
            <NavWrapper>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    Datos Generales
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggleTab("2");
                    }}
                  >
                    Perfil
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggleTab("3");
                    }}
                  >
                    Entrevistas
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "4" })}
                    onClick={() => {
                      toggleTab("4");
                    }}
                  >
                    Estudios Médicos
                  </NavLink>
                </NavItem>
              </Nav>
            </NavWrapper>
            <TabContent style={{ width: "100%", margin: "0 auto" }} activeTab={activeTab}>
              <TabPane className="w-100" tabId="1">
                {activeTab === "1" && (
                  <FormEditCandidato
                    toggle={toggle}
                    info={info}
                    canCreateOV={canCreateOV}
                    createdAt={createdAt}
                    formik={formik}
                    handleReactSelectChange={handleReactSelectChange}
                    provinciaValue={provinciaValue}
                    isLoadingCategoies={isLoadingCategoies}
                    provinciaOptions={provinciaOptions}
                    ciudadOptions={ciudadOptions}
                    ciudadValue={ciudadValue}
                    isLoadingCiudades={isLoadingCiudades}
                    portalValue={portalValue}
                    portalesOptions={portalesOptions}
                    estadoValue={estadoValue}
                    estadosOptionsFiltered={estadosOptionsFiltered}
                    motivoValue={motivoValue}
                    motivo={motivo}
                    motivoOtroValue={motivoOtroValue}
                    motivoOtro={motivoOtro}
                    setShowMotivoNoAvanzaModal={setShowMotivoNoAvanzaModal}
                    showMotivoNoAvanzaModal={showMotivoNoAvanzaModal}
                    handleMotivoNoAvanza={handleMotivoNoAvanza}
                    motivos={motivos}
                    showFechaDeIngreso={showFechaDeIngreso}
                    handleDatesChange={handleDatesChange}
                    fechaDeIngresoValue={fechaDeIngresoValue}
                    fechaActual={fechaActual}
                    handleFileChange={handleFileChange}
                    fileName={fileName}
                    handleDeleteCV={handleDeleteCV}
                    showActiveNotaModal={showActiveNotaModal}
                    setShowActiveNotaModal={setShowActiveNotaModal}
                  />
                )}
              </TabPane>
              <TabPane className="w-100" tabId="2">
                {activeTab === "2" && (
                  <CandidateProfile
                    toggle={toggle}
                    formik={formik}
                    handleReactSelectChange={handleReactSelectChange}
                    estudiosOptions={estudiosOptions}
                    estudiosValue={estudiosValue}
                    nivelDeEstudiosOptions={nivelDeEstudiosOptions}
                    nivelDeEstudiosValue={nivelDeEstudiosValue}
                    areaDeExperienciaOptions={areaDeExperienciaOptions}
                    areasDeExperienciaValue={areasDeExperienciaValue}
                    isLoadingCategoies={isLoadingCategoies}
                  />
                )}
              </TabPane>
              <TabPane className="w-100" tabId="3">
                {activeTab === "3" && (
                  <Interviews toggle={toggle} info={info} handleEditCandidatoNp={handleEditCandidatoNp} derivacionId={derivacionId} notaDePedidoId={notaDePedidoId} />
                )}
              </TabPane>
              <TabPane className="w-100" tabId="4">
                {activeTab === "4" && <MedicalStudies toggle={toggle} info={info} notaDePedidoId={notaDePedidoId} />}
              </TabPane>
            </TabContent>
          </ModalBody>
        </Modal>
      </form>
    </div>
  );
};

export default EditCandidatoFormModal;
